export function changeToReadableDate(unReadableDate) {
const date = new Date(unReadableDate);

const options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

const readableDate = date.toLocaleString('en-US', options);
return readableDate;

}